import { Component } from '@angular/core';
import { NavController, PopoverController, ViewController } from 'ionic-angular';
import { StufenSelector } from '../stufe/stufe';
import { Settings } from '../settings/settings';
import { About } from '../about/about';
import { Service } from '../../app/service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  sponsor1: any;
  sponsor2: any;
  link1: any;
  link2: any;

  constructor(public navCtrl: NavController, public popoverCtrl: PopoverController, private DataProvider: Service) {


    var sponsorimages = [
      "assets/img/logo_sponsor_1.png",
      "assets/img/logo_sponsor_2.png",
      "assets/img/logo_sponsor_3.png",
      "assets/img/logo_sponsor_4.png",
      "assets/img/logo_sponsor_5.png"
    ];
    var sponsorlinks = [
      "mailto:gebhard.baumann@aon.at",
      "http://www.ftk.at",
      "http://www.energieburgenland.at",
      "http://www.blaulichtsms.net",
      "http://www.dlouhy.at"
    ];
    //random sponsor image
    do{
      var s1 = Math.floor(Math.random() * sponsorimages.length);
      var s2 = Math.floor(Math.random() * sponsorimages.length);
      this.sponsor1 = sponsorimages[s1];
      this.sponsor2 = sponsorimages[s2];
      this.link1 = sponsorlinks[s1];
      this.link2 = sponsorlinks[s2];
    }while(this.sponsor1 == this.sponsor2);
  }

  openStufe(event, data) {
    this.navCtrl.push(StufenSelector, {mode: data});
    console.log("open stufenselector", event, data);
  };

  openSettings() {
    this.navCtrl.push(Settings, {data: 0});
  };

  openAbout() {
    this.navCtrl.push(About, {data: 0});
  };

  openSponsor(_sponsor: number) {
    if(_sponsor == 1)
      this.DataProvider.openInBrowser(this.link1);
    else
      this.DataProvider.openInBrowser(this.link2);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts